module.exports = __webpack_public_path__ + "media/images/area-badges/live-better-4a55e899513afab5ce1b2e856034cfd4.svg";